/**
 * 处理本地数据分页的插件，
 * 使用方法： new LocalPagerPlugin({ pageSize: 20 })
 */
export default class LocalPagerPlugin {
  constructor({
    pageSize = 10
  } = {}) {
    this.pageSize = pageSize;
  }

  install(ctx) {
    const self = this;
    ctx.plugin('props', (vm, props) => {
      return { ...props,
        showPager: true
      };
    });
    ctx.plugin('format-page', (vm, pager, data) => {
      const {
        pageSize
      } = self;
      const {
        currentPage = 0
      } = vm;
      data = data || [];
      return {
        total: data.length,
        pageSize,
        pageNumber: currentPage
      };
    });
    ctx.plugin('format-data', (vm, data = []) => {
      const {
        pageSize
      } = self;
      const {
        currentPage = 0
      } = vm;
      data = data || [];
      return data.slice(pageSize * (currentPage - 1), pageSize * currentPage);
    });
  }

}